(function(){

    const isProductPage = document.location.href.includes('/products/');
    if (isProductPage) {

        const recentlyViewedProducts = Cookies.get('adev_recently_viewed_products') ? JSON.parse(Cookies.get('adev_recently_viewed_products')) : [];
        const current_product_handle = window.adev_current_product_handle;

        if (!recentlyViewedProducts.includes(current_product_handle)) {
            recentlyViewedProducts.unshift(current_product_handle);
            if (recentlyViewedProducts.length > 11) {
                recentlyViewedProducts.pop();
            }

            Cookies.set('adev_recently_viewed_products', JSON.stringify(recentlyViewedProducts), { expires: 30, path: '/' });
        }
    }

})();
